import React, {useEffect, useState} from 'react';

import { DSelect, HCheckbox, HDatePicker, HInput, HSelect, passParamsThrough } from '../../../validation/HForm';
import { defaultCountry, documentTypes } from '../../../helpers/data-constants';

import './custom-forms.scss';
import { permissionsAccess, translationRuEnSameLetters} from '../../../helpers/common';
import {useDispatch, useSelector} from 'react-redux';
import {searchGovernmentAgency} from '../../../redux/actions/searchAction';

const DocumentsAdd = ({
     unregister,
     control,
     register,
     errors,
     reset,
     isLoading,
     country,
     handleOptions,
     tempEntity,
     setValue,
   }) => {

    const props = {
      control,
      register,
      errors,
    };

  const dispatch = useDispatch();
  const [ selectedCountry, setSelectedCountry] = useState(tempEntity?.country?.label || '');
  const { governmentAgency } = useSelector(({ search }) => search);
  const [govAgency, setGovAgency] = useState([{ value: 0, label: '' }])
  const isResidency = tempEntity.residency
  const typesDocuments = isResidency ? documentTypes.residency : documentTypes.another;

  const govAgencyAccess = permissionsAccess("action.elastic.search")

    useEffect(() => {
      reset({
        documentType: tempEntity?.documentType,
        startDate: tempEntity?.startDate?.slice(0, 10),
        endDate: tempEntity?.endDate?.slice(0, 10),
        authority: tempEntity?.authority,
        active: tempEntity?.active,
      });
      return () => {
        if (unregister) {
          unregister('active');
        }
      };
    }, [unregister, reset, tempEntity]);

  useEffect(() => {
    if (governmentAgency.length) {
      govAgencyAccess
        ? setGovAgency((prev) => [prev[0], ...governmentAgency.map((i) => ({ value: i.code, label: i.authority }))])
        : setGovAgency([...governmentAgency.map((i) => ({ value: i.code, label: i.authority }))]);
    } else {
      if (govAgencyAccess) setGovAgency((prev) => [prev[0]]);
    }
  }, [governmentAgency, govAgencyAccess]);

  const handleGetGovAgency = (e, action) => {
    if (selectedCountry === 'Беларусь' && action.action === 'input-change' && e.length >= 2) {
      dispatch(searchGovernmentAgency( {"term": e}));
    }
    if (govAgencyAccess) setGovAgency((prev) => [{ value: 0, label: e }, ...prev.slice(1)])
  };

  const handleChoose = (i) => {
    setSelectedCountry(i.label)
    setGovAgency([{ value: 0, label: null }])
  };

    return passParamsThrough(
      <fieldset>
        <div className="form-element">
          <label className="form-element-label" htmlFor="documentType">
            Тип
          </label>
          <div className="form-element-data">
            <HSelect
              h="true"
              className="input"
              type="text"
              name="documentType"
              id="documentType"
              options={['', ...typesDocuments]}
            />

            <HCheckbox
              h="true"
              id="residency"
              name="residency"
              hidden
              defaultValue={isResidency}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="documentNumber">
                Номер
              </label>
              <div className="form-element-data">
                <HInput
                  h="true"
                  className="input"
                  type="text"
                  name="documentNumber"
                  id="documentNumber"
                  defaultValue={tempEntity?.documentNumber || ''}
                  onChange={(event) => translationRuEnSameLetters(event, setValue, "documentNumber", true)}
                />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="startDate">
                Дата выдачи
              </label>
              <div className="form-element-data date">
                <HDatePicker h="true" className="input" name="startDate" id="startDate" />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="endDate">
                Срок действия
              </label>
              <div className="form-element-data date">
                <HDatePicker h="true" className="input" name="endDate" id="endDate" />
              </div>
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="clientAddDocumentProducedBy">
                Орган, выдавший документ
              </label>
              <div className="form-element-data combobox">
                {
                  selectedCountry === 'Беларусь'
                    ? <DSelect
                      h="true"
                      name="govAgency"
                      options={govAgency}
                      handleOptions={handleGetGovAgency}
                      placeholder=""
                    />
                    : <HInput h="true" className="input" type="text" name="authority" id="authority" />
                }
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="clientAddCountry">
                Страна
              </label>
              <div className="form-element-data combobox">
                <DSelect
                  h="true"
                  name="country"
                  isLoading={isLoading}
                  options={country}
                  handleOptions={handleOptions}
                  placeholder="Введите страну"
                  handleOnChange={handleChoose}
                  isOptionDisabled={(option) => !isResidency && option.label === defaultCountry.label}
                />
              </div>
            </div>
          </div>
        </div>
        {
          permissionsAccess("action.client.update.documents") &&
            <div className="form-row">
              <div className="form-row-item">
                <div className="form-element">
                  <label className="form-element-label" htmlFor="clientAddCountry">
                    Активен
                  </label>
                  <div className="form-element-data">
                    <HCheckbox h="true" label="Активен" name="active" />
                  </div>
                </div>
              </div>
            </div>
        }
      </fieldset>,
      props,
    );
  }

export default DocumentsAdd;
